import React, { FocusEvent } from 'react';
import classes from './styles.module.css';
import menuItemDetailsModalClasses from '../shared/styles.module.css';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { Colors } from '@app/config/colors';
import { useMemo } from 'react';
import { usePlaceholderBasedOnConfig } from './helpers';

type Props = {
  value: string;
  onChangeValue: (value: string) => void;
};

export default function ObservationsInput({ value, onChangeValue }: Props) {
  const { primaryColor, restaurant } = useRestaurantContext();

  const color = primaryColor || Colors.DefaultPrimaryColor;

  function handleOnFocusInput(event: FocusEvent<HTMLTextAreaElement>) {
    setTimeout(() => {
      event.target.scrollIntoView(true);
    }, 500);
  }

  const placeholder = usePlaceholderBasedOnConfig(restaurant.Configuracoes?.placeholderCustomizado);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h3 className={menuItemDetailsModalClasses.title} style={{ color }}>
          Observações
        </h3>
      </div>
      <textarea
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        placeholder={placeholder}
        onFocus={handleOnFocusInput}
      />
    </div>
  );
}
